import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

import { formatCount } from '../../utils/helpers/aiSpendFormat';

/** Server-side pagination controls, extracted so every table agrees. */
export default function Pagination({
  page,
  pageSize,
  count,
  onPageChange,
  itemLabel = 'rows',
}) {
  const pageCount = Math.max(1, Math.ceil((count || 0) / pageSize));
  const first = count === 0 ? 0 : (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, count || 0);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 px-4 py-3 text-sm dark:border-slate-700">
      <p className="text-slate-600 dark:text-slate-300">
        Showing {formatCount(first)}–{formatCount(last)} of {formatCount(count || 0)}{' '}
        {itemLabel}
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          aria-label="Previous page"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="rounded-lg border border-slate-300 p-1.5 text-slate-600 disabled:opacity-40 dark:border-slate-600 dark:text-slate-300"
        >
          <ChevronLeftIcon className="h-4 w-4" />
        </button>
        <span className="text-slate-600 dark:text-slate-300">
          Page {page} of {pageCount}
        </span>
        <button
          type="button"
          aria-label="Next page"
          disabled={page >= pageCount}
          onClick={() => onPageChange(page + 1)}
          className="rounded-lg border border-slate-300 p-1.5 text-slate-600 disabled:opacity-40 dark:border-slate-600 dark:text-slate-300"
        >
          <ChevronRightIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
